import React, { Component } from 'react'
import { Button, Modal } from 'antd'
import ImportationStatus from './ImportationStatus'

class BtnImportationStatusRenderer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModalStatus: false
    }
  }

  showModal = () => {
    this.setState({ showModalStatus: true })
  }

  hideModal = () => {
    this.setState({ showModalStatus: false })
  }

  render() {
    return (
      <>
        <Button
          className="button-action-status"
          style={{ backgroundColor: this.props.carga.statusColor }}
          onClick={() => this.showModal()}
        >
          {this.props.carga.status}
        </Button>
        <Modal
          footer={null}
          onCancel={() => {
            this.hideModal()
          }}
          width="70%"
          visible={this.state.showModalStatus}
          onClose={() => {
            this.hideModal()
          }}
        >
          <ImportationStatus setIsModalStatusVisible={this.hideModal} carga={this.props.carga} />
        </Modal>
      </>
    )
  }
}

export default BtnImportationStatusRenderer
